{
  "billing": {
    "cartCleared": "Panier vidé",
    "discountApplied": "Remise appliquée",
    "lineDiscountUpdated": "Remise ligne mise à jour",
    "billHeld": "Facture mise en attente",
    "approvedRetry": "Approuvé — réessayez l'action"
  },
  "toast": {
    "billLoadedCompleteAtBilling": "Bill loaded — complete at billing",
    "heldBillCancelled": "Held bill annulé",
    "heldBillLoaded": "Held bill loaded",
    "saleSavedOfflineWillSyncWhenConnectionReturns": "Sale enregistré offline — will sync when connection returns",
    "scaleDisconnected": "Scale disconnected",
    "labelPrinterReadyUseSystemPrintDialog": "Label printer ready — utiliser system print dialog",
    "labelPrinterDisconnected": "Label printer disconnected",
    "receiptPrinterReadyUseSystemPrintDialog": "Receipt printer ready — utiliser system print dialog",
    "receiptPrinterDisconnected": "Receipt printer disconnected",
    "cashDrawerKickSent": "Cash drawer kick sent",
    "gatewaySaved": "Gateway enregistré",
    "counterCreated": "Counter créé",
    "modifiersSaved": "Modifiers enregistré",
    "shiftClosedSuccessfully": "Quart closed successfully",
    "shiftOpened": "Quart opened",
    "approvedRetryTheAction": "Approved — retry le action",
    "offlineQueueSynced": "Offline queue synced",
    "hardwareConfigSaved": "Hardware config enregistré",
    "customerAdded": "Client ajoutered",
    "couponApplied": "Coupon {{code}} applied",
    "returnProcessedSuccess": "{{type}} processed successfully",
    "scaleConnected": "Scale connected: {{label}}",
    "labelPrinterConnected": "Label printer connected: {{label}}",
    "receiptPrinterConnected": "Receipt printer connected: {{label}}",
    "promotionDiscountApplied": "Promotion discount {{amount}} applied",
    "invoiceCreated": "Invoice {{invoiceNumber}} créé",
    "offlineSaleSynced": "Synced offline sale {{factureNumber}}",
    "workingInStore": "Working in {{magasin}}"
  },
  "errors": {
    "invalidHeldBillData": "Invalid held bill data",
    "failedToLoadHeldBills": "Échec du chargement de held bills",
    "resumeFailed": "Échec de resume",
    "cancelFailed": "Échec de l'annulation",
    "selectABillingCounterBeforePayment": "Sélectionnez un billing counter before payment",
    "selectARegisteredCustomerForWalletPayment": "Sélectionnez un registered customer for wallet payment",
    "selectACreditEnabledCustomer": "Sélectionnez un credit-enabled customer",
    "customerIsNotEnabledForCreditSales": "Client is pas enabled pour credit sales",
    "insufficientPayment": "Insufficient paiement",
    "openShiftBeforePayment": "Open a cashier quart before taking paiement",
    "paymentCancelledInvoiceSavedAsPending": "Paiement annulé — facture enregistré as en attente",
    "splitPaymentRequiresAtLeastTwoTenders": "Split paiement requires at least two tenders",
    "invalidOrExpiredCoupon": "Invalid ou expired coupon",
    "gatewayPaymentFailed": "Échec de gateway payment",
    "couldNotQueueOfflineSale": "Impossible de queue offline sale",
    "checkoutFailed": "Échec de checkout",
    "offlineSaleRejectedByServer": "Offline sale rejeté by server",
    "invoiceNotFoundForThisStore": "Facture pas found pour ce magasin",
    "supervisorApprovalRequired": "Supervisor approbation requis",
    "failedToSaveGateway": "Échec de l'enregistrement de gateway",
    "failedToCreateCounter": "Échec de la création de counter",
    "failedToCloseShift": "Échec : close shift",
    "failedToOpenShift": "Échec : open shift",
    "holdFailed": "Échec de hold",
    "requestRejected": "Request rejeté",
    "failedToLoadApproval": "Échec du chargement de approval",
    "approvalFailed": "Échec de approval",
    "selectARegisteredCustomerForWallet": "Sélectionnez un registered customer for wallet",
    "selectAProductFirst": "Sélectionnez un product first",
    "labelPrintFailed": "Échec de label print",
    "failedToSaveHardwareConfig": "Échec de l'enregistrement de hardware config",
    "openBillingTerminalFirstToCreateADisplay": "Open billing terminal first à create a display session",
    "phoneNumberIsRequired": "Phone number is requis",
    "couldNotCreateCustomer": "Impossible de create customer",
    "insufficientWalletBalance": "Insufficient wallet balance ({{balance}} disponible)",
    "insufficientCredit": "Insufficient credit ({{available}} disponible)",
    "insufficientLoyaltyPoints": "Insufficient loyalty points ({{balance}} disponible)",
    "splitPaymentsMustEqualTotal": "Split paiements ({{sum}}) must equal total {{total}}"
  },
  "pages": {
    "payment": "Paiement",
    "billDiscount": "Bill discount",
    "quantity": "Quantity",
    "printBarcodeLabel": "Print barcode label",
    "weighingScale": "Weighing scale",
    "barcodeLabelPrinter": "Barcode / label printer",
    "thermalReceiptPrinter": "Thermal receipt printer",
    "cashDrawer": "Cash drawer",
    "customerDisplay": "Client display",
    "barcodeScanner": "Barcode scanner",
    "quickAddCustomer": "Quick ajouter client",
    "navigateEnterResumeEscBackTo": "↑↓ navigate · Saisir resume · Esc back à billing",
    "posAnalytics": "POS Analytics",
    "totalSales": "Total sales",
    "transactions": "Transactions",
    "avgBasket": "Avg basket",
    "topProduct": "Top produit",
    "posTerminalReports": "POS Terminal Rapports",
    "noPosActivity": "No POS activity",
    "adjustTheDateRangeOrComplete": "Adjust le date range ou complete sales at le terminal.",
    "returnsExchanges": "Returns & Exchanges",
    "returnRequiresApproval": "Return requires approbation",
    "processCustomerReturnsOrExchanges": "Process client returns ou exchanges",
    "posSetup": "POS Setup",
    "noTaxConfiguration": "No tax configuration",
    "shiftManagement": "Quart Management",
    "selectAStoreFirst": "Sélectionnez un store first",
    "noBillingCountersYet": "No billing counters yet",
    "selectABillingCounter": "Sélectionnez un billing counter",
    "chooseYourStoreFromThePos": "Choose votre magasin de le POS tableau de bord, then return here à open ou close a quart.",
    "useTheCounterDropdownInThe": "Use le Counter dropdown in le top bar (next à votre name), then come back à open ou close votre quart.",
    "heldBillsForStore": "Factures en attente — {{store}}"
  },
  "terminalNav": {
    "billing": "Caisse",
    "held": "En attente",
    "shift": "Quart",
    "returns": "Retours",
    "analytics": "Analyses",
    "setup": "Configuration",
    "dashboard": "Tableau de bord",
    "terminal": "Terminal {{module}}",
    "toggleTheme": "Changer le thème"
  },
  "labels": {
    "commentsOptional": "Comments (optional)",
    "amount": "Amount",
    "paymentMethodOr14": "Paiement method (↑↓ ou 1–4)",
    "amountReceived": "Amount received",
    "loyaltyPointsToRedeem1Pt": "Loyalty points à redeem (1 pt = 1 unit off)",
    "billDiscount": "Bill discount",
    "coupon": "Coupon",
    "discountAmount": "Discount amount",
    "quantity": "Quantity",
    "cart": "Panier",
    "item": "Article",
    "qty": "Qté",
    "total": "Total",
    "productSuggestions": "Produit suggestions",
    "scanBarcodeOrTypeSkuName": "Scan barcode ou type SKU / name",
    "scan": "Scan",
    "scale": "Scale",
    "label": "Label",
    "receipt": "Receipt",
    "display": "Display",
    "selectCounter": "Select counter",
    "searchPhoneNameOrCode": "Search phone, name, ou code",
    "phoneNumber": "Phone number *",
    "customerNameOptional": "Client name (optional)",
    "previousDay": "Previous day",
    "nextDay": "Next day",
    "invoiceIdOrNumber": "Facture ID ou number",
    "reason": "Reason",
    "customerReasonForReturn": "Client reason pour return...",
    "displayName": "Display name",
    "closingCashInDrawer": "Closing cash in drawer",
    "discrepancyReason": "Discrepancy reason",
    "notesOptional": "Notes (optional)",
    "openingCashInDrawer": "Opening cash in drawer",
    "enterAmountCounted": "Saisissez amount counted",
    "explainTheDiscrepancy": "Explain le discrepancy...",
    "anyShiftNotes": "Any quart notes...",
    "eGFloatFromSafe": "E.g. float de safe",
    "lineDiscount": "Line discount"
  },
  "dialogs": {
    "confirmPayment": "Confirmer le paiement"
  },
  "formActions": {
    "cancelBill": "Annuler la facture",
    "addToCart": "Ajouter au panier"
  }
}
